const Notify = {
	snackbar: {
		text: '',
		timeout: 2500
	},
	toast(text, type) {
		let obj = new Object();
		obj.text = text;
		obj.timeout = 2500;
		
		if(type == 'error') {
			obj.color = 'error';
		} else {
			obj.color = '';
		}

		this.snackbar = obj;
	},
	success: {
		loginSuccess() {
			Notify.toast('Welcome!');
		},
		actionSuccess() {
			Notify.toast('Action succeeded');
		},
		itemCreated() {
			Notify.toast('Item created');
		},
		itemUpdated() {
			Notify.toast('Item updated');
		},
		itemDeleted() {
			Notify.toast('Item deleted');
		},
		registerCompleted() {
			Notify.toast('Registration complete!');
		},
		userCreated() {
			Notify.toast('User created');
		},
		userUpdated() {
			Notify.toast('User updated');
		},
		userDeleted() {
			Notify.toast('User deleted');
		},
		uploadSuccess() {
			Notify.toast('Upload success!');
		},
		smsSent() {
			Notify.toast('SMS Sent!');
		},
		copiedToClipboard() {
			Notify.toast('Copied to clipboard! (Try using CTRL V)');
		}
	},
	error: {
		form(formError) {
			formError = Object.values(formError)[2].data; // gets error result
			let errors = Object.values(formError);
			if(errors.length >= 1) {
				Notify.toast(Object.values(errors)[0][0], 'error');
			} else {
				Notify.toast('Check submitted data', 'error');
			}
		},
		invalidCode() {
			Notify.toast('Invalid code entered', 'error');
		},
		invalidPassword() {
			Notify.toast('Invalid password entered', 'error');
		},
		loginFailed() {
			Notify.toast('Invalid credentials', 'error');
		},
		actionFailed() {
			Notify.toast('Action failed', 'error');
		},
		userExists() {
			Notify.toast('That username is already taken', 'error');
		},
		invalidCredentials() {
			Notify.toast('Invalid credentials', 'error');
		},
		checkData() {
			Notify.toast('Check submitted data', 'error');
		}, 
		characterOverflow() {
			Notify.toast('Over the character limit', 'error');
		},
		selectOneOnly() {
			Notify.toast('Select (atleast) one item only', 'error');
		},
		noItemSelected() {
			Notify.toast('No item selected', 'error');
		},
		noChanges() {
			Notify.toast('No changes were made to submitted data', 'error');
		},
		createFailed() {
			Notify.toast('Creation failed. Try refreshing the page', 'error');
		},
		updateFailed() {
			Notify.toast('Update failed. Try refreshing the page', 'error');
		},
		deleteFailed() {
			Notify.toast('Deletion failed. Try refreshing the page', 'error');
		},
		dataUsedSomewhere() {
			Notify.toast('Action failed. This data is currently used somewhere.', 'error');
		},        
		uploadFailed() {
			Notify.toast('Upload failed. Check if you uploaded a valid file.');
		},
		oops(error) {
			Notify.toast('Oops, something went wrong. Try refreshing the page.', 'error');
			if(error) {
				console.log(error);
			}
		}
	},
	data: {
		confirm: {
			title: '',
			text: ''
		},
		prompt: {
			title: '',
			text: '',
			value: ''
		}
	},
	confirm(title, text) {
		let obj = new Object();
		let promise = new Promise((resolve, reject) => {
			obj.resolve = resolve;
			obj.reject = reject;
		});
		obj.title = title;
		obj.text = text;
		this.data.confirm = obj;  
		return promise;
	},

	prompt(title, text, value, options) {
		text = text || '';
		value = value || '';
		options = options || {};
		let obj = new Object();
		let promise = new Promise((resolve, reject) => {
			obj.resolve = resolve;
			obj.reject = reject;
		});
		obj.title = title;
		obj.text = text;
		obj.value = value;
		obj.maxLength = options.maxLength;
		this.data.prompt = obj;
		return promise;
	}
};

export default Notify;